export enum OrderTypeColor {
  SUCCESS = '#79BF1F',
  WARNING = '#FFC224',
  DANGER = '#dd3712',
  CANCELLED = '#97B0BD',
  DEFAULT = '#000000',
}
